import Backbone from 'backbone'
import Dataset from 'scoreboard/datasets/model/dataset'
import conductor from 'scoreboard/components/conductor'
import metadata from 'scoreboard/components/metadata'

/**
 * Performs a navigation drilldown to the page associated with the given chart serie
 *
 * @param {ChartDesigner} chartDesigner
 *
 * @param {ChartDesignerFeature} serie
 *
 * @param {WidgetModel} [widgetModel] for clicks on a chart/chart-table widget,
 * the corresponding widget model
 */
function serieDrilldown ({ chartDesigner, serie, widgetModel }) {
	if (!enabled({ serie })) {
		return
	}

	let typeAndId = domainTypeAndId({ serie })
	if (!typeAndId) {
		return
	}

	let { domainType, domainObjectId } = typeAndId

	if (domainType === 'dataset') {
		let filters
		if (widgetModel) {
			let liveFilters = widgetModel.maestro().liveFilters()
			filters = liveFilters[domainObjectId]
		}

		Backbone.trigger(Dataset.DRILLDOWN, domainObjectId, {
			chartDesigner,
			serie,
			filters
		})
	} else {
		conductor.overview(
			metadata[domainType].section, domainObjectId)
	}
}

/**
 * Returns true if a drilldown navigation is possible on the given serie
 *
 * @param {ChartDesignerFeature} serie
 */
function enabled ({ serie }) {
	if (serie.isCalculated()) {
		// #46002 don't currently support displaying a calculated chart serie
		// on Datasets > Explore
		return false
	}

	return !!domainTypeAndId({ serie })
}

function domainTypeAndId ({ serie }) {
	let domainType = serie.domainType()
	let domainObjectId = serie.domainObjectId()

	return (domainType && domainObjectId) ? { domainType, domainObjectId } : null
}

export default serieDrilldown
export { enabled }

serieDrilldown.__filename__ = 'charts/serie-drilldown.js'
